import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 14px;\n'], ['\n  color: ', ';\n  font-size: 14px;\n']);

import { css } from 'styled-components';
import { colors } from '@atlaskit/theme';

var placeholderStyles = css(_templateObject, colors.placeholderText);

export default placeholderStyles;